export default function findLastIndex(array, callback) {
    for(var i = array.length - 1; i >= 0; i--){
        if (callback(array[i])) {
            return i;
        }
    }
    return -1;
}
